import { Injector } from '@angular/core';
import { draggableNodeStopEvent } from '@examdojo/core/tiptap';
import { mergeAttributes, Node } from '@tiptap/core';
import { AngularNodeViewRenderer } from 'ngx-tiptap';
import { parseJsonAttr } from '../parse-json-attr.util';
import { SimpleSolverNodeComponent } from './simple-solver.component';
import { DEFAULT_SIMPLE_SOLVER_PROPS } from './simple-solver.model';

const simpleSolverClassName = 'simple-solver';
const initialSuperLatexContentDataAttr = 'data-initial-super-latex-content';
const stepsDataAttr = 'data-steps';
const widthDataAttr = 'data-width';
const latexOnRightDataAttr = 'data-latex-on-right';

export const SimpleSolverExtension = (injector: Injector) => {
  return Node.create({
    name: 'simpleSolver',
    group: 'block',
    atom: true,
    selectable: false,
    draggable: true,

    addAttributes() {
      return {
        name: {
          default: null,
        },
        initial_super_latex_content: {
          default: DEFAULT_SIMPLE_SOLVER_PROPS.initial_super_latex_content,
          renderHTML: (attributes) => {
            return {
              [initialSuperLatexContentDataAttr]: JSON.stringify(
                attributes['initial_super_latex_content'] ?? DEFAULT_SIMPLE_SOLVER_PROPS.initial_super_latex_content,
              ),
            };
          },
          parseHTML: (element) =>
            parseJsonAttr(
              element,
              initialSuperLatexContentDataAttr,
              DEFAULT_SIMPLE_SOLVER_PROPS.initial_super_latex_content,
            ),
        },
        steps: {
          default: [],
          renderHTML: (attributes) => {
            return {
              [stepsDataAttr]: JSON.stringify(attributes['steps'] ?? []),
            };
          },
          parseHTML: (element) => parseJsonAttr(element, stepsDataAttr, []),
        },
        width: {
          default: 350,
          renderHTML: (attributes) => {
            return {
              [widthDataAttr]: attributes['width'] ?? 350,
            };
          },
          parseHTML: (element) => {
            const widthStr = element.getAttribute(widthDataAttr);
            return widthStr ? parseInt(widthStr, 10) : 350;
          },
        },
        latex_on_right: {
          default: false,
          renderHTML: (attributes) => {
            return {
              [latexOnRightDataAttr]: attributes['latex_on_right'] ? 'true' : 'false',
            };
          },
          parseHTML: (element) => {
            return element.getAttribute(latexOnRightDataAttr) === 'true';
          },
        },
        class: {
          renderHTML: (attributes) => {
            const otherClasses = ((attributes['class'] ?? '') as string)
              .split(' ')
              .filter((c) => c !== simpleSolverClassName);
            return { class: `${simpleSolverClassName} ${otherClasses.join(' ')}` };
          },
        },
      };
    },

    parseHTML() {
      return [
        {
          tag: `div.${simpleSolverClassName}`,
        },
      ];
    },

    renderHTML({ HTMLAttributes }) {
      return ['div', mergeAttributes({ class: simpleSolverClassName }, HTMLAttributes)];
    },

    addNodeView() {
      return AngularNodeViewRenderer(SimpleSolverNodeComponent, {
        injector,
        stopEvent: draggableNodeStopEvent,
      });
    },
  });
};
